import Carousel from "@stimulus-components/carousel";

export default class extends Carousel {
  connect() {
    super.connect();

    this.defaultOptions
  }

  get defaultOptions() {
    return {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: true,
      spaceBetween: 40,
      breakpoints: {
        1300: {
          slidesPerView: 1.5,
          spaceBetween: 50,
        },
        768: {
          slidesPerView: 1.2,
          spaceBetween: 30,
        },
        350: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
      },
    };
  }
}
